.container {
    background-color: var(--sidebar-primary);
}

.header-container {
    width: 100%;
    background-color: var(--white);
}

.header-content {
    display: grid;
    grid-template-columns: 100px minmax(0, 1fr);
    gap: 4px;
    align-items: start;
    padding: 8px 16px;
}

.assignee-select-container {
    width: 220px;
}

.avatar-column {
    margin-top: -28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

/* Make it visually aligned with other header rows */
.context-overview-container {
    padding-left: 5px;
}

/* Make it visually aligned with other header rows */
.tags-editor-container {
    padding-left: 6px;
}

/* Make it visually aligned with other header rows */
.edit-fields-container {
    padding-left: 5px;
}
